import APIS from "../../constant/EndPoint";
import NACell from "../Reusable/DataTable/NACell";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import DataTable from "../Reusable/DataTable";
//@ts-ignore
import { useState } from "react";
import Modal from "../Reusable/Modal";
import usePermission from "../../customHooks/usePermission";
import { useNavigate } from "react-router-dom";

const ShiftList = (props: any) => {
  const navigate = useNavigate();
  const canEditStaff = usePermission({
    allowedPermissions: ["can_update_staff"],
  });
  const handleRowClick = (row: any) => {
    if (!canEditStaff) return;
    navigate(`edit/${row?.original?.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Shift",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Start Time",
      accessorKey: "start_time",
      cell: NACell,
    },
    {
      header: "End Time",
      accessorKey: "end_time",
      cell: NACell,
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.SHIFT}
        queryKey={"shift"}
        params={{}}
        columns={defaultColumns}
        tableName={"shift-table"}
        onRowClick={handleRowClick}
        addNewPagePath={"create"}
      />
    </>
  );
};

export default ShiftList;
